"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseEvidenceTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var case_lang_1 = require("../../lang/case.lang");
var case_evidence_common_1 = require("./case-evidence-common");
var isNgram = ui_common_1.cmxTypeguards.isNgram, isCategorical = ui_common_1.cmxTypeguards.isCategorical, isUnknownEvidence = ui_common_1.cmxTypeguards.isUnknownEvidence;
var CaseArtifactTypes = ui_common_1.commonEnums.CaseArtifactTypes;
var getCode = function (code) {
    if ('procedure_code' in code) {
        return code.procedure_code;
    }
    else if ('diagnosis_code' in code) {
        return code.diagnosis_code;
    }
    else if ('modifier_code' in code) {
        return code.modifier_code;
    }
};
var CaseEvidenceTable = function (props) {
    var _a, _b;
    var medicalCode = props.medicalCode, artifact = props.artifact, onSelection = props.onSelection, evidenceManager = props.evidenceManager, codeType = props.codeType, rest = __rest(props, ["medicalCode", "artifact", "onSelection", "evidenceManager", "codeType"]);
    var evidenceForCode = (_a = medicalCode.evidence) !== null && _a !== void 0 ? _a : [];
    var fromSource = artifact.type === CaseArtifactTypes.CLINICAL;
    var classes = [
        rest.className,
        'case-evidence-table',
        'col-artifacts',
        "case-evidence-".concat(codeType.toLowerCase()),
        {
            'case-evidence-soure': fromSource,
            'case-has-no-evidence': !evidenceForCode.length
        }
    ];
    return (
    //@ts-ignore
    (0, react_1.createElement)("div", __assign({}, rest, { className: (0, classnames_1["default"])(classes), key: "".concat(artifact.identifier, "-").concat(medicalCode.uuid, "-case-evidence-table") }),
        (0, jsx_runtime_1.jsx)("div", { className: "col-code" }),
        (0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-description" }, { children: [(0, jsx_runtime_1.jsxs)("h5", __assign({ className: "evidence-table-descriptor" }, { children: ["Why we selected ", getCode(medicalCode)] })), !evidenceForCode.length || ((_b = artifact.meta) === null || _b === void 0 ? void 0 : _b.imported) === true
                    ? (0, case_evidence_common_1.displayNoEvidenceAvailable)(artifact)
                    : displayEvidenceList(evidenceForCode, evidenceManager, artifact, medicalCode, onSelection)] }))));
};
exports.CaseEvidenceTable = CaseEvidenceTable;
var displayEvidenceList = function (evidence, evidenceManager, artifact, medicalCode, onSelection) {
    var handleClick = (0, case_evidence_common_1.buildClickHandler)(onSelection, evidence);
    var listItems = evidence.map(function (singleEvidence, index) {
        var feature = ui_common_1.cmxArtifacts.getFeature(singleEvidence);
        var fieldProp;
        if (isNgram(feature)) {
            fieldProp = "".concat(feature.field);
        }
        else if (isCategorical(feature)) {
            fieldProp = "".concat(feature.field);
        }
        else {
            // this is bogus, but really
            // we shouldn't be in here.
            fieldProp = 'undefined';
        }
        var key = "".concat(fieldProp, "-").concat(index, "-").concat(singleEvidence.type);
        var linkable = ui_common_1.cmxArtifacts.isLinkable(fieldProp);
        var featureSelection = {
            evidence: singleEvidence,
            artifactId: artifact.artifact_id,
            code: medicalCode,
            codeType: 'something',
            display: true
        };
        var isActive = evidenceManager.hasSelectedFeature(featureSelection);
        var fieldName = case_lang_1.FieldNames[fieldProp] || fieldProp || 'Unknown field';
        var styleClasses = [
            "case-evidence-item",
            { 'case-evidence-linked': linkable },
            { 'case-evidence-active': isActive },
            { 'sentence-highlight': isNgram(feature) },
            { 'categorical-highlight': isCategorical(feature) }
        ];
        var valueClasses = ["field-value", 'highlighted-text', 'sensitive-data'];
        // we're currently displaying two types of features 'ngrams' and 'categorical' data.
        if (ui_common_1.cmxArtifacts.isSubhighlight(feature)) {
            var descriptions = feature.spans;
            return descriptions.map(function (span) {
                var _a, _b;
                return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: ["The ", (0, jsx_runtime_1.jsx)("span", __assign({ className: "field-name" }, { children: fieldName })), " contains", ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(valueClasses), "data-index": index }, { children: (_a = span.content) === null || _a === void 0 ? void 0 : _a.trim() })), (0, jsx_runtime_1.jsxs)("span", __assign({ className: "highlighter-diagnostics" }, { children: [(_b = span.uuid) === null || _b === void 0 ? void 0 : _b.slice(-7), " ", "".concat(span.start, "-").concat(span.end)] }))] }), "".concat(key, "-").concat(span.uuid)));
            });
        }
        else if (ui_common_1.cmxArtifacts.isBlockHighlight(feature)) {
            var description = ui_common_1.cmxArtifacts.getDescription(feature);
            return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: ["The ", (0, jsx_runtime_1.jsx)("span", __assign({ className: "field-name" }, { children: fieldName })), " is", ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(valueClasses), "data-index": index }, { children: description }))] }), key));
        }
        return false;
    });
    // test for unknown evidence
    var hasUnknown = evidence.some(isUnknownEvidence);
    if (hasUnknown) {
        listItems.unshift((0, jsx_runtime_1.jsx)("li", __assign({ className: 'case-evidence-item' }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "unknown-evidence" }, { children: "Some information was found that is not displayable." })) }), 'unknown-evidence-item'));
    }
    return ((0, jsx_runtime_1.jsx)("ol", __assign({ className: "case-evidence-list", onClick: handleClick }, { children: listItems.flat() }), "".concat(medicalCode.uuid, "-case-evidence-list")));
};
CaseEvidenceTable.displayName = 'CaseEvidenceTable';
//# sourceMappingURL=case-evidence-table.js.map